
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weinkauf/shop/kassa",
      function () {
        return require("private-next-pages/weinkauf/shop/kassa.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weinkauf/shop/kassa"])
      });
    }
  